import { render, staticRenderFns } from "./Dinein.vue?vue&type=template&id=2c686c1e&lang=html"
import script from "./Dinein.vue?vue&type=script&lang=js"
export * from "./Dinein.vue?vue&type=script&lang=js"
import style0 from "./Dinein.vue?vue&type=style&index=0&id=2c686c1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports